export const environment = {
  production: false,
  graphqlUri: '/api/graphql'
};
